import { useSelector } from "react-redux";
import GapsBetweenPlayersPerformance from "./GapsBetweenPlayersPerformance";
import WithoutFtdAndNetRev from "./WithoutFtdAndNetRev";
import AnomaliesSkeleton2 from "../../AnomaliesSkeleton2";

const AnomaliesBrands = () => {
  const isFetchedForBrandData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForBrandData,
  );
  return (
    <>
      {isFetchedForBrandData ? (
        <>
          <WithoutFtdAndNetRev />
          <GapsBetweenPlayersPerformance />
        </>
      ) : (
        <AnomaliesSkeleton2 />
      )}
    </>
  );
};

export default AnomaliesBrands;
